import gql from 'graphql-tag';

export const createCostOffsetCodeMutation = gql(/* GraphQL */ `
  mutation createCostOffsetCode(
    $createCostOffsetCodeRequest: CreateCostOffsetCodeRequest!
  ) {
    accounts {
      createCostOffsetCode(
        createCostOffsetCodeRequest: $createCostOffsetCodeRequest
      ) {
        id
      }
    }
  }
`);
